import React, { Component } from 'react';
import { ISummaryBlocksProps, ISummaryBlocksState } from './models';
import { inject, observer } from 'mobx-react';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent';
import Wrapper from './styledComponents/Wrapper';
import Fact from '@kurtosys/ksys-app-components/dist/components/fact/Fact';

@inject('appStore', 'summaryBlocksStore')
@observer
export class SummaryBlocks extends Component<ISummaryBlocksProps, ISummaryBlocksState> {
	static configurationKey: 'summaryBlocks' = 'summaryBlocks';
	static styleKey: 'summaryBlocks' = 'summaryBlocks';
	constructor(props: ISummaryBlocksProps) {
		super(props);
	}
	render() {
		const { className, summaryBlocksStore } = this.props;

		if (!summaryBlocksStore) {
			return null;
		}

		const { facts } = summaryBlocksStore;

		return (
			<Wrapper className={className}>
				{facts.map(factProps => {
					return <Fact {...factProps} />;
				})}
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(SummaryBlocks, 'summaryBlocks');
